// extracted by mini-css-extract-plugin
export var childrenContainer = "_c7-0";
export var virtualScrollArea = "_c7-1";